import { useState } from "react";

const categories = ["Elektronik", "Aksesuar", "Ofis", "Giyim"];
const brands = ["Logitech", "Samsung", "Apple", "Dell", "HP", "Corsair"];
const warehouses = ["Ana Depo", "İstanbul Şube", "İzmir Şube", "Ankara Şube"];

const allData = [
  { product: "Kablosuz Mouse", category: "Elektronik", brand: "Logitech", stock: 45, sold: 38, match: 84, warehouse: "Ana Depo" },
  { product: "Mechanik Klavye", category: "Elektronik", brand: "Corsair", stock: 32, sold: 28, match: 88, warehouse: "Ana Depo" },
  { product: "27\" Monitör", category: "Elektronik", brand: "Samsung", stock: 12, sold: 15, match: 125, warehouse: "Ana Depo" },
  { product: "USB-C Hub", category: "Aksesuar", brand: "Dell", stock: 88, sold: 42, match: 48, warehouse: "İstanbul Şube" },
  { product: "Webcam 1080p", category: "Elektronik", brand: "Logitech", stock: 24, sold: 22, match: 92, warehouse: "Ana Depo" },
  { product: "Laptop Standı", category: "Aksesuar", brand: "HP", stock: 56, sold: 31, match: 55, warehouse: "Ankara Şube" },
  { product: "VGA Kablo 5m", category: "Aksesuar", brand: "Dell", stock: 0, sold: 5, match: 0, warehouse: "İzmir Şube" },
  { product: "Masa Lambası LED", category: "Ofis", brand: "Samsung", stock: 8, sold: 12, match: 150, warehouse: "Ana Depo" },
];

export default function StockSalesMatchReport() {
  const [searchProduct, setSearchProduct] = useState("");
  const [category, setCategory] = useState("");
  const [brand, setBrand] = useState("");
  const [warehouse, setWarehouse] = useState("");
  const [stockStatus, setStockStatus] = useState("all");

  const data = allData.filter((i) => {
    if (searchProduct && !i.product.toLowerCase().includes(searchProduct.toLowerCase())) return false;
    if (category && i.category !== category) return false;
    if (brand && i.brand !== brand) return false;
    if (warehouse && i.warehouse !== warehouse) return false;
    if (stockStatus === "in_stock" && i.stock === 0) return false;
    if (stockStatus === "out_of_stock" && i.stock > 0) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-accent-600 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Stok Karşılama Rapor Kriterleri</span>
          <button onClick={() => { setSearchProduct(""); setCategory(""); setBrand(""); setWarehouse(""); setStockStatus("all"); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={searchProduct} onChange={(e) => setSearchProduct(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Kategori</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {categories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Marka</label>
            <select value={brand} onChange={(e) => setBrand(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {brands.map((b) => <option key={b} value={b}>{b}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Depo</label>
            <select value={warehouse} onChange={(e) => setWarehouse(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {warehouses.map((w) => <option key={w} value={w}>{w}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Stok Durumu</label>
            <select value={stockStatus} onChange={(e) => setStockStatus(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="all">Hepsini göster</option>
              <option value="in_stock">Stokta olanları göster</option>
              <option value="out_of_stock">Stokta olmayanları göster</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Stok - Satış Karşılama</h2>
        <span className="text-sm text-foreground-500">{data.length} ürün</span>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Kategori</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Stok</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Satış</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Karşılama</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Depo</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.category}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center font-semibold text-foreground-900">{item.stock}</td>
                <td className="px-4 py-3 text-center text-foreground-500">{item.sold}</td>
                <td className="px-4 py-3 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-20 bg-background-200/50 rounded-full h-2 overflow-hidden">
                      <div className={`h-full rounded-full ${item.match >= 100 ? "bg-accent-500" : item.match >= 70 ? "bg-primary-500" : "bg-secondary-500"}`} style={{ width: `${Math.min(item.match, 100)}%` }}></div>
                    </div>
                    <span className={`text-xs font-medium ${item.match >= 100 ? "text-accent-600" : item.match >= 70 ? "text-primary-600" : "text-secondary-600"}`}>{item.match}%</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-foreground-500">{item.warehouse}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <p className="text-sm font-medium text-foreground-900">{item.product}</p>
            <p className="text-xs text-foreground-400">{item.category} · {item.brand} · {item.warehouse}</p>
            <div className="flex items-center justify-between mt-2">
              <div className="flex gap-4">
                <div><p className="text-xs text-foreground-400">Stok</p><p className="text-sm font-semibold text-foreground-900">{item.stock}</p></div>
                <div><p className="text-xs text-foreground-400">Satış</p><p className="text-sm font-semibold text-foreground-900">{item.sold}</p></div>
              </div>
              <span className={`text-sm font-bold ${item.match >= 100 ? "text-accent-600" : item.match >= 70 ? "text-primary-600" : "text-secondary-600"}`}>{item.match}%</span>
            </div>
            <div className="w-full bg-background-200/50 rounded-full h-2 overflow-hidden mt-2">
              <div className={`h-full rounded-full ${item.match >= 100 ? "bg-accent-500" : item.match >= 70 ? "bg-primary-500" : "bg-secondary-500"}`} style={{ width: `${Math.min(item.match, 100)}%` }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}